module.exports = __webpack_public_path__ + "img/map.262a735b.png";